import { useParams } from "react-router-dom";
import { useProduct } from "../../../features/products/hooks/useProduct";
import { BreadcrumbItem } from "../../../components/common/breadcrumbs/Breadcrumbs";
import { HeaderPage } from "../../../components/header-page/HeaderPage";

const breadcrumbItems: BreadcrumbItem[] = [
  { label: "Productos", href: "/dashboard/products" },
  { label: "Historial de Precios" },
];

type ProductPriceHistoryHeaderProps = {
  onNewPriceHistory: () => void;
};

export const ProductPriceHistoryHeader = (
  props: ProductPriceHistoryHeaderProps,
) => {
  const { onNewPriceHistory } = props;
  const { productId = "" } = useParams();
  const { data: productData, isLoading: productIsLoading } = useProduct({
    productId,
  });

  const handleNewPriceHistory = () => {
    onNewPriceHistory();
  };

  return (
    <HeaderPage
      title="Historial de Precios"
      subTitle={productData?.name || ""}
      breadcrumbItems={breadcrumbItems}
      onNew={handleNewPriceHistory}
    />
  );
};
